import * as Sentry from "@sentry/react";
import { shouldIgnoreSentryEvent } from "@workspace/utils";

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const isDev = import.meta.env.DEV;

if (dsn) {
  Sentry.init({
    dsn,
    sendDefaultPii: true,
    tracesSampleRate: isDev ? 1.0 : 0.1,
    integrations: [Sentry.browserTracingIntegration()],
    beforeSend(event, hint) {
      if (shouldIgnoreSentryEvent(event, hint)) {
        return null;
      }
      if (isDev) {
        const err = hint?.originalException;
        const summary =
          err instanceof Error
            ? `${err.name}: ${err.message}`
            : event.message ?? "(no message)";
        console.log(
          `[sentry] ${event.level ?? "error"} captured: ${summary}`,
          err instanceof Error && err.stack ? `\n${err.stack}` : "",
        );
      }
      return event;
    },
  });
} else if (isDev) {
  console.warn(
    "[sentry] VITE_SENTRY_DSN is not set; Sentry is disabled in this app.",
  );
}

export { Sentry };
